<template>
  <div class="add-supplier-request-material">
    <div class="form-row">
      <div class="form-field form-field--grow">
        <div class="field-label">Материал *</div>
        <q-select
          v-model="form.material"
          :options="materials"
          option-value="material_id"
          option-label="material_name"
          outlined
          dense
          emit-value
          map-options
          use-input
          input-debounce="150"
          :loading="loadingMaterials"
          :disable="loading"
          placeholder="Выберите материал"
          @filter="onFilter"
        />
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <div class="field-label">Количество *</div>
        <q-input
          v-model.number="form.material_cnt"
          type="number"
          outlined
          dense
          :disable="loading"
          :min="0.0001"
          placeholder="0"
        />
      </div>
      <div class="form-field">
        <div class="field-label">Цена *</div>
        <q-input
          v-model.number="form.price"
          type="number"
          outlined
          dense
          :disable="loading"
          :min="0"
          placeholder="0"
        />
      </div>
    </div>

    <div class="actions">
      <q-space />
      <q-btn
        color="primary"
        label="Добавить"
        :loading="loading"
        :disable="!canSubmit"
        @click="submit"
      />
    </div>
  </div>
</template>

<script>
import { getMaterialsPoddon, addSupplierRequestItem } from "@/views/SupplierRequests/services";

export default {
  name: "SupplierRequestAddMaterial",
  props: {
    data: { type: Object, required: true },
    closeModal: { type: Function, required: true },
  },
  data() {
    return {
      loading: false,
      loadingMaterials: false,
      materialsAll: [],
      materials: [],
      form: {
        material: null,
        material_cnt: null,
        price: null,
      },
    };
  },
  computed: {
    canSubmit() {
      return (
        !!this.data?.provider_request_id &&
        !!this.form.material &&
        this.form.material_cnt > 0 &&
        this.form.price !== null &&
        this.form.price >= 0
      );
    },
  },
  methods: {
    async loadMaterials() {
      this.loadingMaterials = true;
      try {
        const rows = await getMaterialsPoddon();
        this.materialsAll = rows || [];
        this.materials = this.materialsAll;
      } finally {
        this.loadingMaterials = false;
      }
    },
    onFilter(val, update) {
      update(() => {
        const needle = (val || "").toString().trim().toLowerCase();
        if (!needle) {
          this.materials = this.materialsAll;
          return;
        }
        this.materials = (this.materialsAll || []).filter((m) =>
          (m.material_name || "").toString().toLowerCase().includes(needle)
        );
      });
    },
    async submit() {
      if (!this.canSubmit) return;
      this.loading = true;
      try {
        await addSupplierRequestItem(this.data.provider_request_id, {
          material_id: this.form.material,
          material_cnt: this.form.material_cnt,
          price: this.form.price,
        });

        this.$q.notify({
          type: "positive",
          message: "Материал добавлен в заявку",
          timeout: 2000,
        });

        if (this.data?.onSuccess) {
          await this.data.onSuccess();
        }
        this.closeModal();
      } catch (e) {
        this.$q.notify({
          type: "negative",
          message: e?.response?.data?.error || "Ошибка добавления материала",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.loadMaterials();
  },
};
</script>

<style scoped>
.add-supplier-request-material {
  min-width: 520px;
}

.form-row {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 12px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 160px;
}

.form-field--grow {
  flex: 1;
  min-width: 280px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #9e9e9e;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 6px;
}
</style>

